import type { ReactNode } from "react";

// One compact line of figures, used by the Belege list and every Beleg detail
// (#546). Cards cost a lot of height for a handful of numbers; this keeps the
// work itself above the fold.

export type Figure = {
  label: string;
  value: string;
  hint?: string;
  /** Green for savings, red for extra cost; grey is the default. */
  tone?: "positive" | "negative";
  title?: string;
};

const TONE: Record<"positive" | "negative", string> = {
  positive: "text-emerald-700",
  negative: "text-rose-700",
};

export default function FigureRow({
  figures,
  label = "Kennzahlen",
  /** Ohne Rahmen, wenn die Zahlen der Auftakt einer Seite sind (#541). */
  plain = false,
  children,
}: {
  figures: readonly Figure[];
  label?: string;
  plain?: boolean;
  children?: ReactNode;
}) {
  return (
    <section
      aria-label={label}
      className={`flex flex-wrap items-end gap-x-8 gap-y-3 ${
        plain ? "" : "rounded-lg border border-slate-200 bg-white px-4 py-3"
      }`}
    >
      {figures.map((figure) => (
        <div key={figure.label} className="min-w-0" title={figure.title}>
          <p className="text-xs uppercase tracking-wide text-slate-500">{figure.label}</p>
          <p className={`text-lg font-semibold ${figure.tone ? TONE[figure.tone] : "text-slate-900"}`}>{figure.value}</p>
          {figure.hint ? <p className="text-xs text-slate-500">{figure.hint}</p> : null}
        </div>
      ))}
      {children}
    </section>
  );
}
